import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';

import axios from "../../../../../axios-defaults";
import Spinner from "../../../../UI/Spinner";
import UserContext from '../../../../../context/user-context';

import './css/Form.css';
import RealexHpp from "../../../../../rxp-js";
import {fireGTMPaymentEvent, returnTranslatedPaymentMethod} from "../../../../Utils/GTM/GTMHelper";

class Pay extends PureComponent {
    static contextType = UserContext;

    constructor(props) {
        super(props);

        this.state = {
            show_spinner: true,
            sub_account: props.sub_account,
            amount: props.amount,
            card_resume:false,
            error_message:'',
            verify:true
        }
    }

    savePaymentInfos = (hppResponse) => {
        axios.post(`/globalpayment/savePaymentResponse`,{ hppResponse:hppResponse })
            .then(response => {
                if (response.data.charged){
                    const resume = this.props.t('payment.card_resume',{type:this.props.t('payment.card_type.'+hppResponse.CARDTYPE),last4digits:hppResponse.CARDDIGITS.substr(hppResponse.CARDDIGITS.length - 4)})
                    this.setState(
                        {
                            card_resume:resume,
                            error_message:''
                        }
                    );

                    this.props.setCardUsed(
                        {
                            card_type:hppResponse.CARDTYPE,
                            card_ending:hppResponse.CARDDIGITS.substr(hppResponse.CARDDIGITS.length - 4),
                            name_on_card:hppResponse.CARDNAME,
                            expiration:hppResponse.EXPDATE
                        }
                    )
					const invoicesCount = this.props.invoices.length;
					const invoicesTotal = this.props.amount;
					fireGTMPaymentEvent('3_succes', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `carte-nouvelle`, invoicesCount, invoicesTotal});
				}

            }).catch(error => {
                console.log('/globalpayment/savePaymentResponse error');
			fireGTMPaymentEvent('9_echoue', {mode : returnTranslatedPaymentMethod(this.props.paymentOption), type : `carte-nouvelle`});
			this.props.handleResponse('error',this.props.t('payment.error_message.general'));
            });
    }

    async componentDidMount() {
        await axios.post(`/globalpayment/getPayToken`,
            {
                amount: this.state.amount,
                account: this.context.user.account,
                invoices: this.props.invoices,
                paymentOption: this.props.paymentOption,
                save: this.props.save !== false
            })
            .then(response => {
                RealexHpp.setHppUrl(PAYMENT_HPP_URL);
                RealexHpp.embedded.init(
                    "autoload",
                    "cardPayFrame",
                    function(answer,close){

						if(!(answer.error)){
							this.props.resetMessages()
							this.savePaymentInfos(answer);
							if(answer.AUTHCODE){
								this.props.handleResponse('confirmation', answer.ORDER_ID);
								close();
							}
							else{
								this.props.handleResponse('error',this.props.t('payment.error_message.general'));
								close();
							}
						}
                    }.bind(this),
                    response.data,
                    {
                        onResize:function(data){
                            $('#targetIframe').css(data)
                        }
                    }
                );
                setTimeout(function(){
                    this.setState({show_spinner:false})
                    $('#global-pay-container').show();
                }.bind(this),1000)

            }).catch(error => {
                console.log('[Profile/SavedPaymentMethods/Cards/Forms/Pay.js] : Ajax error in componentDidMount()', error.message);
            });
    }

    render()
    {
        const {show_spinner,card_resume,error_message} = this.state;

        return (
            <div className="container container--larger">
                {show_spinner ? <Spinner />: null}
                {error_message? <p className={'alert alert-danger'}>{error_message}</p>:null }
                {card_resume ? card_resume :
                    <div id={'global-pay-container'}>
                        <iframe id="cardPayFrame">
                        </iframe>
                    </div>
                }
            </div>
        );
    }
}

export default withTranslation()(Pay);



